import { useEffect, useState } from "react";

/**
 * Ticks a "seconds elapsed" counter while `active` is true.
 * Resets to 0 on each new activation. Returns 0 when inactive.
 * Cheap: uses a single setInterval(1000ms) and cleans up on unmount.
 */
export function useElapsedSeconds(active) {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    if (!active) {
      setElapsed(0);
      return undefined;
    }
    const start = Date.now();
    setElapsed(0);
    const id = setInterval(() => {
      setElapsed(Math.floor((Date.now() - start) / 1000));
    }, 1000);
    return () => clearInterval(id);
  }, [active]);
  return elapsed;
}

/** Format seconds as "12s" or "1m 05s" for longer runs. */
export function fmtElapsed(sec) {
  if (!sec || sec < 0) return "";
  if (sec < 60) return `${sec}s`;
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}m ${String(s).padStart(2, "0")}s`;
}
